import { useQuery } from '@tanstack/react-query';

import { PREFIX_URL } from '@/src/api/config';
import { axios } from '@/src/lib/axios/axios';
import { ExtractFnReturnType, QueryConfig } from '@/src/lib/react-query/react-query';
import { generateRoutePath } from '@/src/routes';

import { INBOX_API_KEY } from '../../../../api/config';

// const url = `${PREFIX_URL}/v01/inbox/conversationAndLogs`;
const url = `${PREFIX_URL}/inbox-documents/:fileId/comments`;

type GetCommentsResponse = {
  data: {
    activityLogs: any[];
    conversations: any[];
  };
};

export const getComments = (fileId: number): Promise<GetCommentsResponse> => {
  return axios.get(generateRoutePath(url, { fileId }));
};

export const commentsKeys = {
  all: ['comments'] as const,
  list: (fileId) => [INBOX_API_KEY, ...commentsKeys.all, fileId] as const,
};

type QueryFnType = typeof getComments;

type useComments = {
  fileId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useComments = ({ fileId, config }: useComments) => {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: [INBOX_API_KEY, ...commentsKeys.all, fileId],
    queryFn: () => getComments(fileId),
    staleTime: Infinity,
    ...config,
  });
};
